import styled from 'styled-components'

import PhotoLazy from 'src/comps/PhotoLazy'
import { updatedMedia } from 'client/styles'

export const PhotosZoomBase = styled.div`
  display: flex;
  justify-content: space-between;
  height: calc(100% - 92px);
`

export const PhotoCounter = styled.div`
  color: ${({ theme }) => theme.colors.grey2};
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  margin-inline-start: 56px;
`

export const PhotosContainer = styled.div`
  width: 100%;
  max-width: 1200px;
`

export const Slider = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }

  ${updatedMedia.onlyMobile} {
    transition: transform 0.25s ease-in-out;
  }
`

export const SliderItem = styled(PhotoLazy)`
  flex: 0 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  scroll-snap-align: start;
  scroll-snap-stop: always;
  div {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  img {
    object-fit: contain;
    max-height: 100%;
    max-width: 100%;
    ${updatedMedia.tablet} {
      border-radius: 8px;
    }
  }
`

export const NavigationContainer = styled.div`
  display: none;
  ${updatedMedia.tablet} {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-block: 20px;
    padding-inline: 20px;
    min-width: 88px;
  }
  ${updatedMedia.desktop} {
    padding-block: 40px;
    padding-inline: 40px;
    min-width: 128px;
  }
`
